import { render, staticRenderFns } from "./ReviewIntention.vue?vue&type=template&id=2ac5e460&scoped=true"
import script from "./ReviewIntention.vue?vue&type=script&lang=js"
export * from "./ReviewIntention.vue?vue&type=script&lang=js"
import style0 from "./ReviewIntention.vue?vue&type=style&index=0&id=2ac5e460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5e460",
  null
  
)

export default component.exports